import { render, staticRenderFns } from "./PecaProfissionalIndependenteUserForm.vue?vue&type=template&id=ca347a86"
import script from "./PecaProfissionalIndependenteUserForm.vue?vue&type=script&lang=js"
export * from "./PecaProfissionalIndependenteUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports